export function checkConditions({ conditions = [] }) {
  const conditionsExist = Array.isArray(conditions) && conditions.length > 0;
  
  if (!conditionsExist) { return true };
  
  const allConditionsMet = conditionsExist && conditions.every(c => Boolean(c));

  return allConditionsMet;
}
